'use client';

import { useEffect, useRef } from 'react';
import { useCurrentSlot } from 'src/hooks/useCurrentSlot';
import { useInterval } from 'react-use';

const useCurrentSlotRef = (updateFrequencyMs?: number) => {
	const currentSlot = useCurrentSlot();
	const currentSlotRef = useRef(currentSlot);

	useInterval(
		() => {
			currentSlotRef.current = currentSlot;
		},
		updateFrequencyMs ? updateFrequencyMs : null
	);

	useEffect(() => {
		if (updateFrequencyMs) {
			return;
		}

		currentSlotRef.current = currentSlot;
	}, [currentSlot, updateFrequencyMs]);

	return currentSlotRef;
};

export default useCurrentSlotRef;
